import { BaseBrush } from './BaseBrush';
import { Grid } from '../Grid';

export class GlueTool extends BaseBrush {
    name = 'glue';

    protected applyAt(x: number, y: number, grid: Grid, dist: number, maxDist: number): void {
        const particle = grid.get(x, y);
        // 只对存在的、非空的、粉末状的、且尚未被固定的粒子生效
        if (!particle || particle.empty || !particle.props.isPowder || particle.props.isGlued) {
            return;
        }

        // 应用胶水
        particle.props.isGlued = true;
    }
}
